import { supabase } from "~/integrations/supabase/client";

import type { LibroMayorFilters, LibroMayorLine } from "~/types/contabilidad";

export const libroMayorService = {
  async getLibroMayor(filters: LibroMayorFilters): Promise<LibroMayorLine[]> {
    const { data, error } = await supabase.rpc("get_libro_mayor", {
      p_date_from: filters.dateFrom,
      p_date_to: filters.dateTo,
      p_company_id: filters.companyId,
      p_account_id: filters.accountId || null,
      p_account_code_from: filters.accountCodeFrom || null,
      p_account_code_to: filters.accountCodeTo || null,
    });

    if (error) throw error;
    return data as LibroMayorLine[];
  },
};
